// Conexão em tempo real com o servidor, com reconexão automática.
import type { ClientMessage, ServerMessage } from '../../../shared/src/protocol';

export type ConnState = 'connecting' | 'online' | 'offline';

export class GameConnection {
  private ws: WebSocket | null = null;
  private retry = 0;
  private closed = false;
  private pingTimer: number | undefined;

  constructor(
    private token: string,
    private characterId: number,
    private onMessage: (m: ServerMessage) => void,
    private onState: (s: ConnState, latencyMs?: number) => void,
  ) {
    this.open();
  }

  private open() {
    this.onState('connecting');
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    const ws = new WebSocket(`${proto}://${location.host}/ws`);
    this.ws = ws;
    ws.onopen = () => this.send({ t: 'auth', token: this.token, characterId: this.characterId });
    ws.onmessage = (e) => {
      const msg = JSON.parse(e.data) as ServerMessage;
      if (msg.t === 'welcome') {
        this.retry = 0;
        this.onState('online');
        this.pingTimer = window.setInterval(() => this.send({ t: 'ping', at: performance.now() }), 5000);
      }
      if (msg.t === 'pong') this.onState('online', Math.round(performance.now() - msg.at));
      if (msg.t === 'kicked' || (msg.t === 'error' && /Sess/.test(msg.error))) this.closed = true;
      this.onMessage(msg);
    };
    ws.onclose = () => {
      window.clearInterval(this.pingTimer);
      this.onState('offline');
      if (this.closed) return;
      const delay = Math.min(15000, 1000 * 2 ** this.retry++);
      window.setTimeout(() => !this.closed && this.open(), delay);
    };
  }

  send(m: ClientMessage) {
    if (this.ws?.readyState === WebSocket.OPEN) this.ws.send(JSON.stringify(m));
  }

  close() {
    this.closed = true;
    window.clearInterval(this.pingTimer);
    this.ws?.close();
  }
}
